import { useTranslation } from 'react-i18next';
import { Route,Routes } from 'react-router-dom';
import { GenericTitleHeader } from '../component/common/GenericTitleHeader';
import { DamagePriceList } from '../component/damageListCrud/DamageList';
import SectionHeader from "../../../util/component/SectionHeader";
import Damages from '../component/damageListCrud/creation/Damages';


const DamagePricePage = () => {
    const { t } = useTranslation(["operation"]);
    return (
        <div>
            <SectionHeader
                title={t("damageList.title")}
            />
            <Routes>
                <Route path="/"  element={<DamagePriceList/>} />
                <Route path="/add/*" element={<Damages />} />
            </Routes>
            
        </div>
           
    );
}

export default DamagePricePage;
